/**
 * @generated SignedSource<<b84f5374348b172000e7e89046ad7348>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AreaBackgroundRuleToolInput = {
  colorList?: ReadonlyArray<string> | null;
  enableImageCustomerGallery: boolean;
  enableImageSellerGallery: boolean;
  enableNoColor: boolean;
  id?: string | null;
  imageGalleryCustomerFormat?: number | null;
  name: string;
  printTypeIDs?: ReadonlyArray<string> | null;
  productsSides?: ReadonlyArray<ProductSidesAreaBackgroundRuleInput> | null;
};
export type ProductSidesAreaBackgroundRuleInput = {
  id: string;
  sideGlobalID?: string | null;
};
export type areaBackgroundRuleEditor_UpdateAreaBackgroundRuleMutation$variables = {
  input: AreaBackgroundRuleToolInput;
};
export type areaBackgroundRuleEditor_UpdateAreaBackgroundRuleMutation$data = {
  readonly areaBackgroundRuleSave: {
    readonly id: string;
  };
};
export type areaBackgroundRuleEditor_UpdateAreaBackgroundRuleMutation = {
  response: areaBackgroundRuleEditor_UpdateAreaBackgroundRuleMutation$data;
  variables: areaBackgroundRuleEditor_UpdateAreaBackgroundRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ruleInput",
        "variableName": "input"
      }
    ],
    "concreteType": "AreaBackgroundRuleTool",
    "kind": "LinkedField",
    "name": "areaBackgroundRuleSave",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "areaBackgroundRuleEditor_UpdateAreaBackgroundRuleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "areaBackgroundRuleEditor_UpdateAreaBackgroundRuleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d63a4cd94d931eeb1ab5a67d6584bff1",
    "id": null,
    "metadata": {},
    "name": "areaBackgroundRuleEditor_UpdateAreaBackgroundRuleMutation",
    "operationKind": "mutation",
    "text": "mutation areaBackgroundRuleEditor_UpdateAreaBackgroundRuleMutation(\n  $input: AreaBackgroundRuleToolInput!\n) {\n  areaBackgroundRuleSave(ruleInput: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3284ba15c6fb45910f1b8fce7c15100d";

export default node;
